// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetLessonByIdRequestModel from '../../model/get-lesson-by-id-request-model';
import GetLessonByIdRequestDTO from '../dto/get-lesson-by-id-request-dto';
import dtoSchema from '../schemas/get-lesson-by-id-request-schema';

export default abstract class GetLessonByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetLessonByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetLessonByIdRequestDTO>): GetLessonByIdRequestModel;
  static toModel(dto: DeepPartial<GetLessonByIdRequestDTO> | undefined | null): GetLessonByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetLessonByIdRequestDTO> | undefined | null): GetLessonByIdRequestModel | undefined {
    return dto ? new GetLessonByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetLessonByIdRequestModel> | GetLessonByIdRequestModel): GetLessonByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetLessonByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetLessonByIdRequestModel, can not map to GetLessonByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
